import api from '@/services';
import utils from '@/services/utils';

const state = {
  rules: {
    data: [],
    lastPage: 0,
    page: 1,
    perPage: 25,
    total: 0,
  },
};

const mutations = {
  FETCH_RULES_SUCCESS(state, data) {
    state.rules = data;
  },
};

const actions = {
  async fetchRules({ commit }, data) {
    const response = await utils.request(api.rule.getRules(data));
    if (response && response.status === 200) {
      commit('FETCH_RULES_SUCCESS', response.data);
    }
    return response;
  },

  async getRuleById({ commit }, id) {
    const response = await utils.request(api.rule.getRuleById(id));
    if (response && response.status === 200) {
      return response.data;
    }
    console.error(response);
    return null;
  },

  async updateRuleById({ commit }, data) {
    const response = await utils.request(api.rule.updateRuleById(data));
    if (response && response.status === 200) {
      return response.data;
    }
    console.error(response);
    return null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/rule.js